import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import { DrawerContent } from "./DrawerContent";
import "./Drawer.scss";

interface DrawerInfoProps {
  drawerOpen: boolean;
  closeDrawer: () => void;
}

export const DrawerInfo: React.FC<DrawerInfoProps> = ({
  drawerOpen,
  closeDrawer,
}) => {
  const [isMobileView, setIsMobileView] = React.useState(
    window.innerWidth < 1200
  );

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 1200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onDrawerClose = () => {
    closeDrawer();
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Box component="nav" aria-label="mailbox folders">
        <Drawer
          variant={isMobileView ? "temporary" : "permanent"}
          open={drawerOpen}
          className="drawer-section"
          onClose={onDrawerClose}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
            },
          }}
        >
          <DrawerContent
            onDrawerItemClick={onDrawerClose}
            isMobileView={isMobileView}
          />
        </Drawer>
      </Box>
    </Box>
  );
};
